import { createContext, useContext } from "react";
import type { ApiClient } from "../lib/api";
import type { TurnstileClient } from "../lib/turnstile";

export interface Services {
  api: ApiClient;
  turnstile: TurnstileClient;
  /** Base URL of the SSE endpoints (same origin as the API). */
  streamUrl: (path: string) => string;
}

export const ServicesContext = createContext<Services | null>(null);

export function useServices(): Services {
  const s = useContext(ServicesContext);
  if (!s) throw new Error("ServicesContext missing");
  return s;
}
